export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 76 76" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-546.000000, -4926.000000)">
                    <g id="编组-2" transform="translate(510.000000, 4798.000000)">
                        <g id="Microware_icon" transform="translate(36.000000, 128.000000)">
                            <rect id="矩形备份-25" x="0" y="0" width="76" height="76"></rect>
                            <g
                                id="编组-40"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                transform="translate(6.000000, 19.000000)"
                                stroke="#000000"
                                strokeWidth="2"
                            >
                                <path
                                    d="M61.2195882,38.5952452 L3.10310974,38.5952452 C2.24627335,38.5952452 1.4697336,38.2476318 0.908673473,37.6855552 C0.346596928,37.1244951 0,36.3489718 0,35.4911189 L0,3.10514257 C0,2.13243506 0.446205431,1.26441812 1.14549777,0.695226685 C1.68013115,0.261218214 2.36112805,0 3.10310974,0 L61.2195882,0 C62.0022265,0 62.716765,0.289677785 63.2625789,0.767392027 C63.9130835,1.33556705 64.3237145,2.17207519 64.3237145,3.10514257 L64.3237145,35.4911189 C64.3237145,36.3845463 63.9466251,37.1895455 63.3418592,37.7556878 C62.7868976,38.2771077 62.0408503,38.5952452 61.2195882,38.5952452 Z"
                                    id="Stroke-57"
                                ></path>
                                <line x1="46.9377662" y1="0.000304923987" x2="46.9377662" y2="38.5955501" id="Stroke-59"></line>
                                <polygon
                                    id="Stroke-61"
                                    points="6.08838404 33.0820162 41.0072623 33.0820162 41.0072623 5.51383877 6.08838404 5.51383877"
                                ></polygon>
                                <line x1="46.9377662" y1="29.4058526" x2="63.6109077" y2="29.4058526" id="Stroke-63"></line>
                                <path
                                    d="M59.3281495,9.18969739 C59.3281495,11.2194747 57.6825763,12.8650478 55.6517826,12.8650478 C53.6220054,12.8650478 51.9764322,11.2194747 51.9764322,9.18969739 C51.9764322,7.15992007 53.6220054,5.51434697 55.6517826,5.51434697 C57.6825763,5.51434697 59.3281495,7.15992007 59.3281495,9.18969739 Z"
                                    id="Stroke-64"
                                ></path>
                                <path
                                    d="M59.3286576,20.2168668 C59.3286576,22.246644 57.6830847,23.8922172 55.6522909,23.8922172 C53.6225135,23.8922172 51.9769404,22.246644 51.9769404,20.2168668 C51.9769404,18.186073 53.6225135,16.5415163 55.6522909,16.5415163 C57.6830847,16.5415163 59.3286576,18.186073 59.3286576,20.2168668 Z"
                                    id="Stroke-65"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
